import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import ExtendedAuthForm from "components/AuthForm/ExtendedAuthForm";
import { useNavigate, useParams } from "react-router-dom";
import AlertContext from "components/Common/ModalAlert";
import { updateUserByPhone } from "services/firebase";
import Background from "assets/badges/background.jpg";
import AuthForm from "components/AuthForm/AuthForm";
import { Header } from "components/Common/Header";

import { useEffect, useContext } from "react";
import { useEvent } from "hooks/useEvent";

import Text from "components/Common/Text";
import { useAuth } from "hooks/useAuth";

// eslint-disable-next-line react/prop-types
function UpdateHDCP({ user }) {
  const { error } = useContext(AlertContext);
  const { eventId } = useParams();

  const navigation = useNavigate();

  async function update() {
    if (user) {
      const res = await updateUserByPhone({
        // eslint-disable-next-line react/prop-types
        uid: user.uid,
        // eslint-disable-next-line react/prop-types
        phoneNumber: user.phone,
      });

      if (res.handicap) {
        error(
          "Handicap is updated",
          // eslint-disable-next-line max-len
          "You handicap has been updated",
          100,
          () => {
            // navigation(`/event/${eventId}`);
            // window.location.reload();
          },
        );
      }
    }
    return navigation(`/event/${eventId}/`);
  }

  useEffect(() => {
    update();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <ActivityIndicator />;
}

// eslint-disable-next-line react/prop-types
function TeeTimePlayerNotJoined({ extendedAuth, updateHDCP }) {
  const { user } = useAuth();

  const { eventId } = useParams();
  const event = useEvent(eventId);

  function formSelector() {
    if (extendedAuth) {
      return <ExtendedAuthForm />;
    }
    if (updateHDCP) {
      return <UpdateHDCP user={user} />;
    }
    return <AuthForm />;
  }

  return (
    <>
      <Header event={event} userData={user} showTitle />
      <div
        style={{
          flex: 1,
          height: "100%",
          backgroundImage: `url(${Background})`,
          backgroundPosition: "right",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#2977A4",
          backgroundBlendMode: "soft-light",
          marginTop: -10,
          zIndex: 0,
        }}
      >
        <flex style={{ alignSelf: "center", paddingTop: 50 }}>
          <img
            src="https://kecamps.com/_media/camp_logos/mobile_logo.png"
            alt="ccm logo"
            style={{
              height: 88,
              width: 88,
              borderRadius: 23,
              boxShadow: "0px 12.6667px 50.6667px rgba(0, 0, 0, 0.25)",
            }}
          />
        </flex>
        <flex style={{ margin: "0px 32px" }}>
          <Text
            as="H3"
            ta="center"
            mt={20}
            bold
            style={{ textShadow: "0px 10px 40px rgba(0, 0, 0, 0.25)" }}
          >
            Get ready to tee off with CCM Golf Games!
          </Text>
          <Text
            as="P3"
            ta="center"
            mt={4}
            style={{ textShadow: "0px 10px 40px rgba(0, 0, 0, 0.25)" }}
          >
            To get started, we&apos;ll just need your mobile number. Don&apos;t
            worry, we won&apos;t ask for it again.
          </Text>
        </flex>

        <flex style={{ padding: "16px" }}>{formSelector()}</flex>
      </div>
    </>
  );
}

export { TeeTimePlayerNotJoined };
